import styled from "styled-components";

export const Wrapper = styled.div`
  @media (min-width: 1100px) {
    width: 92%;
  }
  @media (min-width: 800px) {
    width: 92%;
  }
`;
export const Container = styled.div`
  padding: 1em;
`;
export const Row = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 45% 55%;
  margin-bottom: 1.5em;
  background: ${({ themed }) => (themed ? "#0F0E37" : "#ffffff")};
  padding: 1em;
  border-radius: 15px;
  box-shadow: ${({ themed }) =>
    themed ? "0 0 15px #04031D" : "0 0 15px #eee"};
`;
export const Col = styled.div``;
export const Image = styled.div`
  width: 80%;

  img {
    width: 100%;
    border-radius: 10px;
  }
`;
export const Disp = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  h5 {
    margin: 0;
    margin-bottom: 0.4em;
  }
`;

export const Dot = styled.div`
  display: flex;
  flex-direction: column;
`;
export const ContentWrapper = styled.div`
  height: 100%;
  display: flex;
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 1em;

  .content-menu {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
`;
